import { useMemo } from 'react'

import { DIALOG_IDS, modalStore } from '@core/modal'
import { useActions } from '@core/store'

import { checkoutStore } from '../store/checkoutStore'
import { type TCheckoutRequest } from '../types/checkoutTypes'

export const useCheckoutDialog = () => {
    const actions = useActions({
        setRequest: checkoutStore.actions.setRequest,
        openModal: modalStore.actions.open,
        closeModal: modalStore.actions.close,
    })

    return useMemo(
        () => ({
            open: (request: TCheckoutRequest) => {
                actions.setRequest(request)
                actions.openModal(DIALOG_IDS.checkout)
            },
            close: () => {
                actions.setRequest(null)
                actions.closeModal()
            },
        }),
        [actions],
    )
}
